import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import { SVG_paymentMethod } from '../elements/SVG';
import { BlockRenewalDecline } from './BlockRenewalDecline';

export const BlockPayment = ({ payment }) => {

    const { mainReducer } = useContext( MainContext );

    return  <>  
                {((mainReducer.state.realUser === false) || ((mainReducer.state.realUser !== false) && (mainReducer.state.realUser.email == mainReducer.state.currentPaymentMethod.payer))) ?
                    <>
                        <span className="e__plns__opt__pay__wpr__save__ico">
                            <SVG_paymentMethod type={payment.type} />
                        </span>             
                        <div className="e__plns__opt__pay__info__wpr">
                            <span className="e__plns__opt__pay__info__hd">{ getText('payment_method_title_' + payment.type) }</span>
                            <span className="e__plns__opt__pay__info__nmbr">{ getText('payment_method_prefix_' + payment.type) } { payment.description }</span>
                            <BlockRenewalDecline paymentMethodId={ payment.id } />
                            {(mainReducer.state.cardExpiresBeforeRenewal) && (payment.id == mainReducer.state.currentPaymentMethod.id) &&
                                <span className="e__plns__opt__pay__rejected">{ getText('card_expires_before_renewal') }</span>
                            }
                        </div>
                        {(payment.expires !== false) &&
                            <div className="e__plns__opt__pay__info__date">{ getText('caduca')}: { payment.expiresLabel }</div>
                        }
                    </>
                :
                    <>
                        <span className="e__plns__opt__pay__wpr__save__ico">
                            <SVG_paymentMethod type="payer" />
                        </span>                                   
                        <div className="e__plns__opt__pay__info__wpr">
                            <span className="e__plns__opt__pay__info__hd">{ getText('payment_method_title_payer') }</span>
                            <span className="e__plns__opt__pay__info__nmbr">{ mainReducer.state.currentPaymentMethod.payer }</span>
                        </div>
                    </>
                }
            </>;
}